<template>
    <div style="height: 100%;">
        <div v-if="list.length == 0">
            <div :class="{'choose_item':true,'active':category_id == index}" @click="changeCategoryId(index)">
                <span>不限</span>
            </div>
        </div>
        <div v-else class="list_wrap">
            <div class="category_col scrollbar">
                <div v-for="(item,i) in list" :key="i" :class="{'category_name':true,'active':activeCategoryId == item.category_id}" @click="showCategory(item.category_id)">
                    {{ item.category_name }}
                </div>
            </div>
            <div class="children_col scrollbar" v-if="currentCategory">
                <div class="children-item">
                    <div :class="{'choose_item':true,'active':category_id == currentCategory.category_id}" @click="changeCategoryId(currentCategory.category_id)">
                        <span>不限</span>
                    </div>
                    <div :class="{'choose_item':true,'active':category_id == item.category_id}" v-for="(item,k) in (currentCategory.children || [])" :key="k" @click="changeCategoryId(item.category_id)">
                        <span>{{ item.category_name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'List',
    props: {
        list: [Array,Object],
        index: [Number,String],
        type: {
            type: Number,
            default: 1
        },
        ct: [Number,String],
        immediate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            category_id: this.type == 2 ?(this.$store.state.category_id2 || ''):(this.$store.state.category_id || ''),
            activeCategoryId: ''
        }
    },
    computed: {
        storeCategoryId() {
            return this.type == 2 ? (this.$store.state.category_id2 || '') : (this.$store.state.category_id || '')
        },
        storeCategoryType() {
            return this.type == 2 ? (this.$store.state.category_type2 || '') : (this.$store.state.category_type || '')
        },
        currentCategory() {
            if (this.activeCategoryId === '' || this.activeCategoryId === null || this.activeCategoryId === undefined) return null
            return this.list.find(item => item.category_id == this.activeCategoryId) || null
        }
    },
    methods: {
        syncActiveCategory(list) {
            const val = Array.isArray(list) ? list : this.list
            if (!val || val.length == 0) {
                this.activeCategoryId = ''
                return
            }

            const selectedId = this.category_id || this.storeCategoryId
            let target = ''
            if (selectedId !== '' && selectedId !== null && selectedId !== undefined) {
                val.some(item => {
                    if (item.category_id == selectedId) {
                        target = item.category_id
                        return true
                    }
                    const children = item.children || []
                    if (children.some(child => child.category_id == selectedId)) {
                        target = item.category_id
                        return true
                    }
                    return false
                })
            }
            if (target) {
                this.activeCategoryId = target
                return
            }

            const ct = this.storeCategoryType || this.index
            if (ct !== '' && ct !== null && ct !== undefined) {
                const hasCt = val.some(item => item.category_id == ct)
                if (hasCt) {
                    this.activeCategoryId = ct
                    return
                }
            }

            this.activeCategoryId = val[0].category_id
        },
        showCategory(category_id) {
            this.activeCategoryId = category_id
        },
        changeCategoryId(category_id) {
            this.category_id = category_id
            if (this.immediate) {
                this.confirm()
                this.$emit('confirmed')
            }
        },
        reset() {
            this.category_id = ''
        },
        confirm() {
            if(this.list.length == 0) {
                if(this.type != 2) {
                    this.$store.commit('setCt',this.index)
                    this.$store.commit('setCi',this.index)
                    return
                }else {
                    this.$store.commit('setCt2',this.index)
                    this.$store.commit('setCi2',this.index)
                }
            }else {
                if(this.type != 2) {
                    this.$store.commit('setCt',this.index)
                    this.$store.commit('setCi',this.category_id)
                }else {
                    this.$store.commit('setCt2',this.index)
                    this.$store.commit('setCi2',this.category_id)
                }
            }
        }
    },
    watch: {
        list: {
            immediate: true,
            handler(val) {
                this.syncActiveCategory(val)
            }
        },
        storeCategoryId: {
            immediate: true,
            handler(val) {
                this.category_id = val
                this.syncActiveCategory()
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .list_wrap {
        display: flex;
        height: 100%;
    }
    .category_col {
        width: 50%;
        padding-right: 1rem;
        border-right: 1px solid #f2f2f2;
    }
    .children_col {
        width: 50%;
        padding-left: 1rem;
    }
    .category_name {
        font-size: 1.3rem;
        margin-bottom: .8rem;
        color: #606060;
        height: 3rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.active {
            color: var(--theme);
            font-weight: 700;
        }
    }
    .choose_item {
        float: left;
        width: 45%;
        font-size: 1.3rem;
        margin-bottom: .8rem;
        color: #606060;
        height: 3rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.active {
            color: var(--theme);
            font-weight: 700;
        }
    }
    .children-item {
        padding: 0 0.1rem;
        // .choose_item:nth-child(3n+1) {
        //     margin: 0 .8rem 1rem;
        // }
    }
</style>